import { render, staticRenderFns } from "./QueueCardMaKuang.vue?vue&type=template&id=3f5c062b&"
import script from "./QueueCardMaKuang.vue?vue&type=script&lang=js&"
export * from "./QueueCardMaKuang.vue?vue&type=script&lang=js&"
import style0 from "./QueueCardMaKuang.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports